import Vue from 'vue';
import DealerLocator from '../module/dealer_locator/DealerLocator';

import '../../../scss/app/dealer_locator.scss';

new Vue({
  components: {
    DealerLocator,
  },
  el: '.js-dealer-locator',
});
